var _style, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwpx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2B2B2B;}\n\t.st1{fill:url(#SVGID_1_);}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 8,
    cy: 8,
    r: 8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.9697,
    y1: 9.9,
    x2: 13.0487,
    y2: 9.9,
    gradientTransform: "matrix(1 0 0 -1 0 18)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCFF2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FF87"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.6,8C5.4,6.5,4.2,5.1,3,3.6c0.1,0,0.2,0,0.3,0c0.8,0,1.6,0,2.4,0c0.1,0,0.2,0,0.3,0.2C7.1,5.2,8.2,6.6,9.3,8 c0.1,0.1,0.1,0.2,0,0.3C8.2,9.6,7.1,11,6,12.4c-0.1,0.1-0.2,0.2-0.3,0.2c-0.9,0-1.7,0-2.7,0C4.2,11,5.4,9.5,6.6,8z M10.1,10.1 c0.1,0.1,0.2,0.2,0.3,0.2c0.8,0,1.6,0,2.4,0c0.1,0,0.1,0,0.2,0c-0.9-1.1-1.8-2.2-2.7-3.4c0.9-1.1,1.8-2.2,2.7-3.3 c-0.1,0-0.2,0-0.3,0c-0.7,0-1.4,0-2.1,0C10.2,3.6,10,3.7,9.8,4C9.4,4.5,8.9,5,8.5,5.6C9.2,6.4,9.8,7.2,10.4,8 c-0.3,0.4-0.6,0.8-1,1.2C9.7,9.6,9.9,9.8,10.1,10.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwpx);
export default __webpack_public_path__ + "static/media/swpx.715d93bdb3fe82c2babec571211473ed.svg";
export { ForwardRef as ReactComponent };